<template>
    <CCard>
        <CCardBody>
            <v-toolbar flat color="white">
                <v-toolbar-title>پرداخت ها و هزینه ها</v-toolbar-title>
                <v-spacer></v-spacer>
                <CButton color="info" class="mb-2 ml-2 text-white"
                         @click="addItem">
                    پرداخت/هزینه جدید
                </CButton>
                <v-dialog v-model="dialog" max-width="500px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">{{formTitle}}</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm4 md4>
                                        <div class="form-group">
                                            <label>مبلغ پرداخت</label>
                                            <money v-model="editedItem.price" v-bind="money" dir="ltr"
                                                   class="form-control"/>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm4 md4>
                                        <div class="form-group">
                                            <label>کارمزد</label>
                                            <money v-model="editedItem.wage" v-bind="money" dir="ltr"
                                                   class="form-control"/>
                                        </div>
                                    </v-flex>       
                                    <v-flex xs12 sm4 md4>
                                        <CInput
                                                label="شماره پیگیری"
                                                v-model="editedItem.reference_id"
                                                :is-valid="validations.reference_id.isValid"
                                                :invalid-feedback="validations.reference_id.error"
                                        />
                                    </v-flex>                                                                 
                                    <v-flex xs12 sm6 md6>
                                        <div class="form-group">
                                            <label>تاریخ پرداخت</label>
                                            <date-picker v-model="editedItem.payment_date"
                                                        type="datetime"
                                                         input-format="YYYY-MM-DD HH:mm:ss"
                                                         locale="fa" format="YYYY-MM-DD"
                                                         display-format="jYYYY-jMM-jDD HH:mm:ss">
                                            </date-picker>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                      <div class="form-group">
                                        <label>تاریخ سند</label>
                                        <date-picker v-model="editedItem.doc_date"
                                                     type="date"
                                                     input-format="YYYY-MM-DD"
                                                     locale="fa" format="YYYY-MM-DD"
                                                     display-format="jYYYY-jMM-jDD">
                                        </date-picker>
                                      </div>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <div class="form-group">
                                            <label>انتخاب حساب</label>
                                            <v-autocomplete
                                                    v-model="editedItem.account_id"
                                                    :items="categories.accounts"
                                                    :item-text="(item)=>{return item.name}"
                                                    :item-value="(item)=>{return item.account_id}"
                                                    dense
                                            />
                                            <label class="text-danger" v-if="!validations.account_id.isValid">{{validations.account_id.error}}</label>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm6 md6>
                                        <div class="form-group">

                                          <CInput
                                              label="شناسه شخص"
                                              v-model="editedItem.contact_id"
                                              :is-valid="validations.contact_id.isValid"
                                              :invalid-feedback="validations.contact_id.error"
                                          />
                                          <contact-searcher v-model="editedItem.contact_id"></contact-searcher>
                                        </div>
                                    </v-flex>
                                    <v-flex xs12 sm4 md4>
                                        <div class="form-group">
                                            <label>دسته بندی پرداخت</label>
                                            <select class="form-control" v-model="editedItem.payment_category_id">
                                                <option v-bind:value="category.category_id"
                                                        v-bind:key="category.category_id"
                                                        v-for="category in categories.categories">{{category.name}}
                                                </option>
                                            </select>
                                            <label class="text-danger" v-if="!validations.payment_category_id.isValid">{{validations.payment_category_id.error}}</label>
                                        </div>
                                    </v-flex>

                                    <v-flex xs12 sm4 md4>
                                        <CInput
                                                label="شماره مشتری"
                                                v-model="editedItem.customer_id"
                                                :is-valid="validations.customer_id.isValid"
                                                :invalid-feedback="validations.customer_id.error"
                                        />
                                    </v-flex>
                                    <v-flex xs12 sm4 md4>
                                        <CInput
                                                label="شناسه فاکتور خرید"
                                                v-model="editedItem.bill_id"
                                                :is-valid="validations.bill_id.isValid"
                                                :invalid-feedback="validations.bill_id.error"
                                        />
                                    </v-flex>                                    
                                    <v-flex xs12 sm12 md12>
                                        <CInput
                                                label="توضیحات"
                                                v-model="editedItem.description"
                                                :is-valid="validations.description.isValid"
                                                :invalid-feedback="validations.description.error"
                                        />
                                    </v-flex>
                                    <v-flex xs12 sm12 md12>
                                        <div class="form-group">
                                            <label>فایل ضمیمه</label>
                                            <v-file-input dense v-model="editedItem.fileUpload"/>
                                        </div>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <CButton color="danger" class="mb-2 ml-2 text-white"
                                     @click="close">
                                انصراف
                                <CIcon :content="$options.iconsSet.cilBan"/>
                            </CButton>
                            <CButton color="primary" class="mb-2 ml-2 text-white"
                                     @click="save">
                                ذخیره
                                <CIcon :content="$options.iconsSet.cilSave"/>
                            </CButton>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="logDialog" max-width="700px">
                    <v-card>
                        <v-card-title>
                            <span class="headline">تاریخچه</span>
                        </v-card-title>
                        <v-card-text>
                            <v-container grid-list-md>
                                <v-layout wrap>
                                    <v-flex xs12 sm12 md12>
                                        <v-data-table
                                                :headers="logsHeaders"
                                                :items="selectedItemLogs"
                                                sort-by="log_id"
                                                :hide-default-footer="true"
                                                :disable-pagination="true"
                                                class="elevation-1">
                                            <template v-slot:item="{item}">
                                                <tr>
                                                    <td>{{ item.log_id }}</td>
                                                    <td>{{ item.action }}</td>
                                                    <td>{{ item.user_fullname }}</td>
                                                    <td>{{ convertDateToJDate(item.set_date) }}</td>
                                                </tr>
                                            </template>
                                        </v-data-table>
                                    </v-flex>
                                </v-layout>
                            </v-container>
                        </v-card-text>
                        <v-card-actions>
                            <v-spacer></v-spacer>
                            <CButton color="danger" class="mb-2 ml-2 text-white"
                                     @click="logDialog = false">
                                بستن
                                <CIcon :content="$options.iconsSet.cilBan"/>
                            </CButton>
                        </v-card-actions>
                    </v-card>
                </v-dialog>
            </v-toolbar>
            <CCard>
                <CCardHeader @click="collapse = !collapse">
                    <CIcon name="cil-justify-center"/>
                    <strong> فیلتر </strong>
                </CCardHeader>
                <CCollapse :show="collapse" :duration="400">
                    <CCardBody>
                        <CRow>
                            <CCol sm="2">
                                <CInput
                                        label="مبلغ"
                                        type="number"
                                        v-model="filters.price"
                                />
                            </CCol>
                            <CCol sm="2">
                                <CInput
                                        label="شناسه پرداخت"
                                        type="number"
                                        v-model="filters.payment_id"
                                />
                            </CCol>
                            <CCol sm="2">
                                <div class="form-group">
                                    <label>تاریخ پرداخت</label>
                                    <date-picker v-model="filters.payment_date"
                                                 input-format="YYYY-MM-DD HH:mm:ss"
                                                 locale="fa" format="YYYY-MM-DD"
                                                 display-format="jYYYY-jMM-jDD">
                                    </date-picker>

                                </div>
                            </CCol>
                            <CCol sm="2">
                                <div class="form-group">
                                    <label>زیر مجموعه</label>
                                    <select class="form-control" v-model="filters.payment_category_id">
                                        <option v-bind:value="category.category_id"
                                                v-bind:key="category.category_id"
                                                v-for="category in categories.categories">{{category.name}}
                                        </option>
                                    </select>
                                </div>
                            </CCol>
                            <CCol sm="2">
                              <div class="form-group">
                                <label>حساب</label>
                                <select class="form-control" v-model="filters.account_id">
                                  <option v-bind:value="category.account_id"
                                          v-bind:key="category.account_id"
                                          v-for="category in categories.accounts">{{category.name}}
                                  </option>
                                </select>
                              </div>
                            </CCol>
                            <CCol sm="4">
                                <CInput
                                        label="توضیحات"
                                        v-model="filters.description"
                                />
                            </CCol>

                            <CCol sm="2">
                                <div class="form-group">
                                    <label>از تاریخ سند</label>
                                    <date-picker v-model="filters.doc_date_from"
                                                 input-format="YYYY-MM-DD HH:mm:ss"
                                                 locale="fa" format="YYYY-MM-DD"
                                                 display-format="jYYYY-jMM-jDD">
                                    </date-picker>
                                </div>
                            </CCol>

                            <CCol sm="2">
                                <div class="form-group">
                                    <label>تا تاریخ سند</label>
                                    <date-picker v-model="filters.doc_date_to"
                                                 input-format="YYYY-MM-DD HH:mm:ss"
                                                 locale="fa" format="YYYY-MM-DD"
                                                 display-format="jYYYY-jMM-jDD">
                                    </date-picker>
                                </div>
                            </CCol>


                        </CRow>
                    </CCardBody>
                    <CCardFooter class="text-left">
                        <CButton size="sm" color="primary" class="text-white" @click="applyFilters()">
                            <CIcon name="cil-check-circle"/>
                            اعمال
                        </CButton>
                        <CButton size="sm" color="danger" class="text-white mr-1" @click="resetFilters()">
                            <CIcon name="cil-ban"/>
                            حذف فیلتر ها
                        </CButton>
                    </CCardFooter>
                </CCollapse>
            </CCard>



            <CCard v-if="drafts.show">
                <CCardHeader >
                    <CIcon name="cil-justify-center"/>
                    <strong>اطلاعات</strong>
                </CCardHeader>                
                <CCardBody>
                    جمع تراکنش ها: 
                    {{ payments.balance | currency('', 0, { symbolOnLeft: false }) }} ریال
                    <br />
                    مانده حواله حساب: 
                    {{ (-1 * drafts.balance) | currency('', 0, { symbolOnLeft: false }) }} ریال
                    <br />
                    مانده نهایی: 
                    {{ (payments.balance - drafts.balance) | currency('', 0, { symbolOnLeft: false }) }} ریال
                </CCardBody>
            </CCard>                    

            <CCard v-if="drafts.show">
                <CCardHeader >
                    <CIcon name="cil-justify-center"/>
                    <strong>حواله های حساب</strong>
                </CCardHeader>                
                <CCardBody>
                    

                        <CRow class="text-left" dir="ltr">
                            <CButton color="dark" class="mb-2 ml-2 text-white"
                                    v-c-tooltip="'خروجی بصورت فایل PDF'"
                                    @click="refreshDrafts('pdf')">
                                <CIcon :content="$options.iconsSet.cilFilePdf"/>
                            </CButton>
                            <CButton color="dark" class="mb-2 ml-2 text-white"
                                    v-c-tooltip="'خروجی بصورت فایل اکسل'"
                                    @click="refreshDrafts('excel')">
                                <CIcon :content="$options.iconsSet.cilFileExcel"/>
                            </CButton>
                        </CRow>
                        <v-data-table
                                :headers="drafts.header"
                                :items="drafts.list"
                                :server-items-length="drafts.count"
                                :footer-props="{
                                            'items-per-page-options': [25, 50 ,100]
                                }"
                                :options.sync="drafts.options"
                                sort-by="draft_id"
                                class="elevation-1">
                                <template v-slot:item="{item}">
                                    <tr>
                                        <td>{{ item.draft_id }}</td>
                                        <td>{{ getObjectNameById(drafts.types,'id',item.from_type) }}</td>
                                        <td>{{ item.from_id }}</td>
                                        <td>{{ getObjectNameById(drafts.types,'id',item.to_type) }}</td>
                                        <td>{{ item.to_id }}</td>
                                        <td>{{ item.price | currency('', 0, { symbolOnLeft: false }) }} ریال</td>
                                        <td>{{ convertDateToJDate(item.set_date) }}</td>
                                        <td>{{ item.comment }}</td>
                                        
                                        
                                        <td>

                                            <v-icon
                                                    v-c-tooltip="'نمایش تاریخچه'"                            
                                                    medium
                                                    @click="showLogDialog('draft',item.draft_id)">
                                                mdi-information
                                            </v-icon>
                                        </td>
                                    </tr>
                                </template>
                        </v-data-table>
                    
                </CCardBody>
            </CCard>




            <CCard>
                <CCardHeader >
                    <CIcon name="cil-justify-center"/>
                    <strong>پرداخت ها و هزینه ها</strong>
                </CCardHeader>                
                <CCardBody>

                    <CRow class="text-left" dir="ltr">
                        <CButton color="dark" class="mb-2 ml-2 text-white"
                                v-c-tooltip="'خروجی بصورت فایل PDF'"
                                @click="refreshPayments('pdf')">
                            <CIcon :content="$options.iconsSet.cilFilePdf"/>
                        </CButton>
                        <CButton color="dark" class="mb-2 ml-2 text-white"
                                v-c-tooltip="'خروجی بصورت فایل اکسل'"
                                @click="refreshPayments('excel')">
                            <CIcon :content="$options.iconsSet.cilFileExcel"/>
                        </CButton>
                    </CRow>
                    <v-data-table
                            :headers="payments.header"
                            :items="payments.list"
                            :search="search"
                            :server-items-length="payments.count"
                            :footer-props="{
                                        'items-per-page-options': [100,25, 50]
                            }"
                            :options.sync="payments.options"
                            sort-by="payment_id"
                            sort-desc
                            class="elevation-1">
                        <!--                <template v-slot:top>-->
                        <!--                    <v-text-field v-model="search" label="جستجو" class="mx-4 text-right"></v-text-field>-->
                        <!--                </template>-->
                        <template v-slot:item="{item}">
                            <tr>
                                <td>{{ item.payment_id }}</td>
                                <td>{{ item.reference_id }}</td>
                                <td>{{ convertDateToJDate(item.payment_date) }}</td>
                                <td>{{ convertDateToJDateOnly(item.doc_date) }}</td>
                                <td>{{ item.price | currency('', 0, { symbolOnLeft: false }) }} ریال</td>
                                <td>{{ getObjectNameById(categories.accounts,'account_id',item.account_id) }}</td>
                                <td>{{ getObjectNameById(categories.contacts,'contact_id',item.contact_id,'family') }}</td>
                                <td>{{ item.description }}</td>
                                <td>
                                    <v-icon v-if="item.attachment"
                                            v-c-tooltip="'فایل'"
                                            medium
                                            class="mr-2"
                                            @click="showFile(item.attachment)">
                                        mdi-image-area
                                    </v-icon>
                                    <v-icon
                                            v-c-tooltip="'ویرایش'"
                                            medium
                                            class="mr-2"
                                            @click="editItem(item,false)">
                                        mdi-pencil
                                    </v-icon>
                                    <v-icon
                                    v-c-tooltip="'حذف'"                            
                                            medium
                                            @click="deletePayments(item)">
                                        mdi-delete
                                    </v-icon>
                                    <v-icon
                                    v-c-tooltip="'نمایش تاریخچه'"                            
                                            medium
                                            @click="showLogDialog('payment',item.payment_id)">
                                        mdi-information
                                    </v-icon>
                                </td>
                            </tr>
                        </template>
                        <template v-slot:no-results>
                            <v-alert :value="true" color="error">
                                جستجوی "{{ search }}" هیچ نتیجه ای در بر نداشت!
                            </v-alert>
                        </template>
                    </v-data-table>
                </CCardBody>
            </CCard>

        </CCardBody>
    </CCard>
</template>

<script>
    import {getCategoryType, functionAction, getPayments, getFunction, uploadFile,formatDate} from '../../webservice/webservice';
    import {iconsSet} from '../../assets/icons/icons'
    import VuePersianDatetimePicker from 'vue-persian-datetime-picker'
    import moment from "moment-jalaali";

    export default {
        name: 'Payments',
        iconsSet,
        components: {
            datePicker: VuePersianDatetimePicker
        },
        props: {
            items: Array,
            fields: {
                type: Array,
                default() {
                    return ['username', 'registered', 'role', 'status']
                }
            },
            caption: {
                type: String,
                default: 'Table'
            },
            hover: Boolean,
            striped: Boolean,
            bordered: Boolean,
            small: Boolean,
            fixed: Boolean,
            dark: Boolean
        },
        methods: {
            getObjectNameById(list, key, id, extraKey) {
                for (let i = 0; i < list.length; i++) {
                    if (list[i][key] === id) {
                        if (extraKey) {
                            return list[i].name + ' ' + list[i][extraKey]
                        }
                        return list[i].name
                    }
                }
            },
            convertDateToJDate(dt) {
                let convertedDate = moment(dt, 'YYYY-MM-DD HH:mm:ss').format('jYYYY/jM/jD HH:mm:ss');
                if (convertedDate === 'Invalid date') {
                    return 'نامعلوم'
                }
                return convertedDate
            },
            convertDateToJDateOnly(dt) {
              let convertedDate = moment(dt, 'YYYY-MM-DD').format('jYYYY/jM/jD');
              if (convertedDate === 'Invalid date') {
                return 'نامعلوم'
              }
              return convertedDate
            },
            initialize() {
                getCategoryType(this.$http, 9).then((resp) => {
                    this.categories.categories = resp.list;
                    getFunction(this.$http, 'accounts', 0, 1000, 'sort_order', 'desc', {}).then((resp) => {
                        this.categories.accounts = resp.list;
                        getFunction(this.$http, 'contacts', 0, 1000, 'name', 'desc', {}).then((resp) => {
                            this.categories.contacts = resp.list
                        });
                    });
                });
            },
            addItem() {
                this.editedItem = {
                    account_id: "",
                    attachment: "",
                    bill_id: "",
                    contact_id: "",
                    customer_id: "",
                    description: "",
                    payment_category_id: "",
                    payment_date:  formatDate(new Date()),
                    doc_date:  formatDate(new Date()),
                    payment_id: "",
                    price: "",
                    reference_id: ""
                };
                this.dialog = true
            },
            editItem(item) {
                this.editedIndex = this.payments.list.indexOf(item);
                this.editedItem = Object.assign({}, item);
                this.dialog = true
            },
            close() {
                this.dialog = false;
                this.$nextTick(() => {
                    this.editedItem = Object.assign({}, this.defaultItem);
                    this.editedIndex = -1
                })
            },
            save() {
                let self = this;
                Object.keys(this.validations).map((key) => {
                    this.validations[key].error = '';
                    this.validations[key].isValid = null;
                });
                let action = this.editedIndex === -1 ? 'add' : 'update';
                if (this.editedItem.fileUpload) {
                    uploadFile(this.$http, this.editedItem.fileUpload).then((resp) => {
                        self.editedItem.attachment = resp.filename;
                        delete self.editedItem.fileUpload;
                        self.saveEditItem(action);
                    })
                } else {
                    this.saveEditItem(action)
                }

            },
            saveEditItem(action) {
                if (action === 'add') {
                    this.editedItem.payment_id = ''
                }
                functionAction(this.$http, 'payments', action, this.editedItem).then((resp) => {
                    if (resp.success) {
                        this.$toasted.show(resp.message, {
                            theme: "toasted-primary",
                            position: "bottom-center",
                            duration: 3000
                        });
                        Object.keys(this.validations).map((key) => {
                            this.validations[key] = {isValid: null, error: ''}
                        });
                        this.refreshPayments();
                        this.close()
                    } else {
                        let errors = resp.body.errors;
                        Object.keys(errors).map((k) => {
                            this.validations[k] = {isValid: false, error: errors[k]}
                        });
                    }
                });
            },
            deletePayments(item) {
                var r = confirm("آیا مطمین هستید؟");
                if (r == true) {                 
                    Object.keys(item).map((key) => {
                        if (item[key] === null) {
                            item[key] = ''
                        }
                    });
                    functionAction(this.$http, 'payments', 'delete', item).then((resp) => {
                        if (resp.success) {
                            this.$toasted.show(resp.message, {
                                theme: "toasted-primary",
                                position: "bottom-center",
                                duration: 3000
                            });
                            this.refreshPayments();
                        } else {
                            this.$toasted.show("اطلاعات ارسالی اشتباه است.", {
                                theme: "toasted-danger",
                                position: "bottom-center",
                                duration: 5000
                            });
                        }
                    });
                }
            },
            applyFilters(){
                this.refreshPayments();
                this.refreshDrafts();
                this.drafts.show = (this.filters.payment_category_id ? true : false);
            },
            resetFilters() {
                this.filters = {
                    price: '',
                    payment_id: '',
                    payment_date: '',
                    description: '',
                    doc_date_from: '',
                    doc_date_to: '',
                    payment_category_id: 0,
                };
                this.refreshPayments();
                this.refreshDrafts();
                this.filteredReq = {}
                
            },
            refreshPayments(fileType) {
                let filters = Object.assign({}, this.filters);
                Object.keys(filters).forEach(function (key) {
                    if (filters[key] === '' || filters[key] === 0) {
                        delete filters[key]
                    } else {
                        filters[key] = `${filters[key]}`;
                    }
                });
                getPayments(this.$http, 
                    ((this.payments.options.page-1) * this.payments.options.itemsPerPage),
                    this.payments.options.itemsPerPage,  
                    this.payments.options['sortBy'][0], 
                    this.payments.options['sortDesc'][0] ? 'desc' : 'asc', 
                    filters, 
                    fileType).then((resp) => {
                    if (fileType !== undefined) {
                        if (fileType === 'pdf') {
                            window.open(resp.fileurl, '_blank');
                            return;
                        }
                        const link = document.createElement('a');
                        link.href = resp.fileurl;
                        link.setAttribute('download', 'accounts.' + ((fileType === 'pdf') ? 'pdf' : 'xls'));
                        document.body.appendChild(link);
                        link.click()
                    } else {
                        this.payments.list = resp.list;
                        this.payments.count = resp.count;
                        this.payments.balance = resp.balance;
                    }
                });
                this.filteredReq = filters;
            },
            refreshDrafts(fileType) {
                
                if(this.filters.payment_category_id){
                    var draftFilters = {
                        type: 4,
                        id: this.filters.payment_category_id
                    };

                    getFunction(this.$http, 
                        'drafts/getlist', 
                        ((this.drafts.options.page-1) * this.drafts.options.itemsPerPage),
                        this.drafts.options.itemsPerPage, 
                        (this.drafts.options['sortBy'] ? this.drafts.options['sortBy'][0] : ''), 
                        (this.drafts.options['sortDesc'] && this.drafts.options['sortDesc'][0]) ? 'desc' : 'asc', 
                        draftFilters, 
                        fileType).then((resp) => {
                        if (fileType !== undefined) {
                            if (fileType === 'pdf') {
                                window.open(resp.fileurl, '_blank');
                                return;
                            }                        
                            const link = document.createElement('a');
                            link.href = resp.fileurl;
                            link.setAttribute('download', 'drafts.' + ((fileType === 'pdf') ? 'pdf' : 'xls'));
                            document.body.appendChild(link);
                            link.click()
                        } else {
                            this.drafts.list = resp.list;
                            this.drafts.count = resp.count;
                            this.drafts.balance = resp.balance;
                            
                        }
                    });
                }
            },               
            isNumber: function (evt) {
                evt = (evt) ? evt : window.event;
                let charCode = (evt.which) ? evt.which : evt.keyCode;
                if ((charCode < 48 || charCode > 57)) {
                    evt.preventDefault();
                } else {
                    return true;
                }
            },
            showFile(attachment) {
                window.open('https://api.erp.masterkala.com/1.0.0/tools/images/' + attachment, '_blank');
            },
            showLogDialog(code,code_id) {
                this.logDialog = true;
                getFunction(this.$http, 'logs', 0, 1000, 'name', 'desc', {
                    "code": code,
                    "code_id": code_id
                }).then((resp) => {
                    this.selectedItemLogs = resp.list
                })
            }
        },
        computed: {
            formTitle() {
                return this.editedIndex === -1 ? 'پرداخت/هزینه جدید' : 'ویرایش پرداخت/هزینه'
            },
        },
        data: () => {
            return {
                dialog: false,
                payments: {
                    header: [
                        {text: 'شماره پرداخت', value: 'payment_id'},
                        {text: 'شماره پیگیری', value: 'reference_id'},
                        {text: 'تاریخ پرداخت', value: 'payment_date'},
                        {text: 'تاریخ سند', value: 'doc_date'},
                        {text: 'مبلغ', value: 'price'},
                        {text: 'حساب', value: 'account_id'},
                        {text: 'شخص', value: 'contact_id'},
                        {text: 'توضیحات', value: 'description'},
                        {text: 'عملیات', value: 'actions', sortable: false},
                    ],                  
                    list: [],
                    count: 0,
                    balance: 0,
                    options: {}
                },                
                drafts: {
                    header: [
                        {text: 'شماره حواله', value: 'draft_id'},
                        {text: 'بدهکار:نوع', value: 'from_type'},
                        {text: 'بدهکار:شناسه', value: 'from_id'},
                        {text: 'بستانکار:نوع', value: 'to_type'},
                        {text: 'بستانکار:شناسه', value: 'to_id'},
                        {text: 'مبلغ', value: 'price'},
                        {text: 'تاریخ', value: 'set_date'},
                        {text: 'توضیحات', value: 'comment'},
                        {text: 'عملیات', value: 'actions', sortable: false},
                    ],                
                    types: [
                        {id: '1', name: 'شخص'},
                        {id: '2', name: 'مشتری'},
                        {id: '3', name: 'حساب'},
                        {id: '4', name: 'پرداخت'},
                        {id: '5', name: 'دریافت'},
                    ],                          
                    list: [],
                    count: 0,
                    balance: 0,
                    show: false,
                    options: {}
                },  
                logsHeaders: [
                    {text: 'شناسه', value: 'log_id'},
                    {text: 'عملیات', value: 'action'},
                    {text: 'کاربر', value: 'user_fullname'},
                    {text: 'زمان', value: 'set_date'}
                ],

                editedIndex: -1,
                editedItem: {
                    account_id: "",
                    attachment: "",
                    bill_id: "",
                    contact_id: "",
                    customer_id: "",
                    description: "",
                    payment_category_id: "",
                    payment_date: "",
                    doc_date: "",
                    payment_id: "",
                    price: "",
                    reference_id: ""
                },
                validations: {
                    price: {isValid: null, error: ''},
                    reference_id: {isValid: null, error: ''},
                    customer_id: {isValid: null, error: ''},
                    description: {isValid: null, error: ''},
                    account_id: {isValid: null, error: ''},
                    contact_id: {isValid: null, error: ''},
                    bill_id: {isValid: null, error: ''},
                    payment_category_id: {isValid: null, error: ''},
                },
                search: '',
                categories: {
                    categories: [],
                    accounts: [],
                    contacts: []
                },
                collapse: false,
                filters: {
                    price: '',
                    payment_id: '',
                    payment_date: '',
                    description: '',
                    doc_date_to: '',
                    doc_date_from: '',
                    payment_category_id: 0,
                },
                tableOption: {
                    sortDesc: true,
                    sortedField: 'name',
                    itemsPerPage: 10,
                    page: 1
                },
                filteredReq: {},
                money: {
                    decimal: '',
                    thousands: ',',
                    prefix: '',
                    suffix: '',
                    precision: 0,
                    masked: false
                },
                logDialog: false,
                selectedItemLogs: []
            }
        },
        mounted() {
            if (this.$route.params.id) {
              this.filteredReq = this.filters = {payment_id: this.$route.params.id};
            }
            this.initialize()
        },
        watch: {
            dialog(val) {
                val || this.close()
            },
            'payments.options': {
                handler(value) {
                    this.refreshPayments();
                },
                deep: true,
            },
            'drafts.options': {
                handler(value) {
                    this.refreshDrafts();
                },
                deep: true,
            },                
        },
    }
</script>
